import api from "services/api";

// Get all tasks
export const getTasks = async () => {
  return api.get("/v1/api/tasks/get");
};

// Get tasks with query params (project_id, assigned_to)
export const getTasksWithParams = async (params) => {
  return api.get("/v1/api/tasks/get", { params });
};

// Create a new task
export const createTask = async (taskData) => {
  return api.post("/v1/api/tasks/create", taskData);
};

// Update a task
export const updateTask = async (taskId, taskData) => {
  return api.patch(`/v1/api/tasks/update/${taskId}`, taskData);
};

// Update task status
export const updateTaskStatus = async (taskId, statusData) => {
  return api.patch(`/v1/api/tasks/update-status/${taskId}`, statusData);
};

// Delete a task
export const deleteTask = async (taskId) => {
  return api.delete(`/v1/api/tasks/delete/${taskId}`);
};
